import EventTarget from './EventTarget';

export default class BarEventTarget extends EventTarget {
	constructor(params) {
		super(params);
		this.x = params.x;
	}
}
